<template>
    <div>
        <AuditReport/>
    </div>
</template>
<script>
import AuditReport from '../components/AuditReport.vue';
export default {
  components: {
    AuditReport
  },
};
</script>